import React from 'react'
import { connect } from 'react-redux'

// colorWhenUnfiltered: every category button shows its color while no filter is applied;
// once a filter is selected only that button keeps its color and the rest go grey
const FilterButtons = ({ onHandleFilterClick, selectedFilter, filterObjects, colorWhenUnfiltered = false }) => {
    const filterClasses = (filter) => {
        if (colorWhenUnfiltered) {
            const isColored = !selectedFilter || selectedFilter === filter.name
            return `btn small ${isColored ? `category-${filter.color}` : 'grey'} ${selectedFilter === filter.name ? 'active' : ''}`
        }
        return `btn small grey ${selectedFilter === filter.name ? `${filter.color}-bg active` : ''}`
    }

    const renderFilterButtons = () => {
        return filterObjects.map((filter, index) => {
            return (
                <button
                    key={index}
                    className={filterClasses(filter)}
                    onClick={() => onHandleFilterClick(filter.name)}>
                    {filter.name}
                </button>
            )
        })
    }

    return (
        <div className={`filter-buttons ${colorWhenUnfiltered ? 'color-when-unfiltered' : ''}`}>
            <button className={`btn small grey ${!selectedFilter ? 'All' : ''}`} onClick={() => onHandleFilterClick(null)}>All</button>
            {renderFilterButtons()}
        </div>
    )
}

export default connect()(FilterButtons)
